import { useMatchesParams } from "@quortex/front-common/adapters/react-location"

export const useBasePath = () => {
  const { orgUuid } = useMatchesParams()
  return `/organizations/${orgUuid}/switch`
}

export const useWorkspacePath = () => {
  const { orgUuid, workspaceUuid } = useMatchesParams()
  return `/organizations/${orgUuid}/switch/workspaces/${workspaceUuid}`
}
